var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-message',{attrs:{"error":""}},[_c('sui-message-content',[_c('p',[_vm._v(" Ihre Anmeldung wird demnächst gelöscht. Bitte verlängern Sie Ihre Anmeldung, wenn Sie weiterhin Bedarf an einer Heimunterbrinung haben. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }